const $ = jQuery.noConflict();
// import FormLabel from './formLabel';

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f380-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	classSpan: 'span',
	$domFirstTimeImporting: $('input[name=first-time-importing]'),
	$domCustomsBond: $('input[name=customs-bond]'),
	$domShippingToAmazon: $('input[name=shipping-to-amazon]'),

	$domFirstNameInput: $('.js-cf7-holder .contact-form__box-wrapper').find('input[name="first-name"]'),
	$domLastNameInput: $('.js-cf7-holder .contact-form__box-wrapper').find('input[name="last-name"]'),


	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.requestQuoteOnSubmit();
		this.preventCharactersFromInput();

		setTimeout(function() {
			// const loader = document.querySelector('.js-loader');
			// loader.classList.add('loader-hidden');
			$('.js-loader').addClass('loader-hidden');
		}, 1000);

		this.$domFirstTimeImporting.addClass('selected-first-time-importing');
		this.addClassOnClickingOnFirstTimeImporting();

		this.$domCustomsBond.addClass('selected-customs-bond');
		this.addClassOnClickingOnCustomsBond();

		this.$domShippingToAmazon.addClass('selected-shipping-to-amazon');
		this.addClassOnClickingOnShippingToAmazon();
	},

	preventCharactersFromInput: function() {
		const invalidChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
		FormHelpers.$domFirstNameInput.on('keydown', function(e) {
			if (invalidChars.includes(e.key)) {
				//Preventing invalid characters from being entered
				e.preventDefault();
			}
		});

		FormHelpers.$domLastNameInput.on('keydown', function(e) {
			if (invalidChars.includes(e.key)) {
				//Preventing invalid characters from being entered
				e.preventDefault();
			}
		});

		//Preventing cut copy paste
		FormHelpers.$domFirstNameInput.bind('cut copy paste', function(e) {
			e.preventDefault();
		});

		FormHelpers.$domLastNameInput.bind('cut copy paste', function(e) {
			e.preventDefault();
		});
	},

	addClassOnClickingOnFirstTimeImporting: function() {
		this.$domFirstTimeImporting.on('click', (evt) => {
			$('input[name=first-time-importing]').removeClass('selected-first-time-importing');
			evt.currentTarget.value;
			evt.currentTarget.classList.add('selected-first-time-importing');
		});
	},

	addClassOnClickingOnCustomsBond: function() {
		this.$domCustomsBond.on('click', (evt) => {
			$('input[name=customs-bond]').removeClass('selected-customs-bond');
			evt.currentTarget.value;
			evt.currentTarget.classList.add('selected-customs-bond');
		});
	},

	addClassOnClickingOnShippingToAmazon: function() {
		this.$domShippingToAmazon.on('click', (evt) => {
			$('input[name=shipping-to-amazon]').removeClass('selected-shipping-to-amazon');
			evt.currentTarget.value;
			evt.currentTarget.classList.add('selected-shipping-to-amazon');
		});
	},

	requestQuoteOnSubmit: function() {
		$('#wpcf7-f48-o1').on('submit', () => {
			const shippingType = $('.location-widget__input-dropdown-button--active').text();
			// eslint-disable-next-line
			const transportationBy = $('.js-main-select')[0].getAttribute('data-shorthand').trim();
			// eslint-disable-next-line
			const am = $('.js-am').val();
			// eslint-disable-next-line
			const kg = $('.js-kg').val();
			// eslint-disable-next-line
			const cbm = $('.js-cbm').val();
			// eslint-disable-next-line
			const option = $('.js-display-standard')[0].textContent.split('\' ');
			const size = option[0];
			const container = option[1];
			// eslint-disable-next-line
			const amAir = $('.js-air-am').val();
			// eslint-disable-next-line
			const kgAir = $('.js-air-kg').val();
			// eslint-disable-next-line
			const cbmAir = $('.js-air-cbm').val();
			// eslint-disable-next-line camelcase
			const first_name = $('input[name=first-name]').val();
			// eslint-disable-next-line camelcase
			const last_name = $('input[name=last-name]').val();
			// eslint-disable-next-line camelcase
			const phone_number = $('input[name=phone]').val();
			const email = $('input[name=email]').val();
			const message = $('textarea[name=message]').val();
			let firstTimeImporting = $('.selected-first-time-importing').val();
			//give me back the boolean value
			firstTimeImporting = firstTimeImporting === 'Yes';
			let customsBond = $('.selected-customs-bond').val();
			customsBond = customsBond === 'Yes';
			let shippingToAmazon = $('.selected-shipping-to-amazon').val();
			shippingToAmazon = shippingToAmazon === 'Yes';
			// eslint-disable-next-line camelcase
			const port_from = $('input[name=location-from]').val().split(' ');
			// eslint-disable-next-line camelcase
			const lastWordPortFrom = port_from[port_from.length - 1].slice(1, -1);
			// eslint-disable-next-line camelcase
			const port_to = $('input[name=location-to]').val().split(' ');
			// eslint-disable-next-line camelcase
			const lastWordPortTo = port_to[port_to.length - 1].slice(1, -1);
			const date = $('.js-date-new')[0].value;

			// eslint-disable-next-line camelcase
			const jsonData = {
				// eslint-disable-next-line camelcase
				'port_from': lastWordPortFrom,
				// eslint-disable-next-line camelcase
				'port_to': lastWordPortTo,
				'date': date,
				// eslint-disable-next-line camelcase
				'shipping_type': shippingType,
				...(shippingType === 'Ocean') && {'transportation_by': transportationBy},
				...(shippingType === 'Ocean' && transportationBy !== 'FCL') && {
					...(am) && {'carton_count': am},
					...(kg) && {'kg': kg},
					...(cbm) && {'cbm': cbm},
				},
				...(shippingType === 'Ocean' && (transportationBy === 'FCL')) && {
					'container_size': size,
					'container_type': container
				},
				...(shippingType !== 'Ocean') && {
					...(amAir) && {'carton_count': amAir},
					...(kgAir) && {'kg': kgAir},
					...(cbmAir) && {'cbm': cbmAir},
				},
				// eslint-disable-next-line camelcase
				'first_name': first_name,
				// eslint-disable-next-line camelcase
				'last_name': last_name,
				// eslint-disable-next-line camelcase
				'phone_number': phone_number,
				'email': email,
				'message': message,
				'firstTimeImporting': firstTimeImporting,
				'customsBond': customsBond,
				'shippingToAmazon': shippingToAmazon,
			};
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'callSendingJsonObjectToUrl',
					jsonData: jsonData
				}
			});
		});
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: () => {
		document.addEventListener('wpcf7mailsent', () => {
			// const formId = e.detail.id;
			console.log('afterFormSubmit');
			localStorage.removeItem('input1');
			localStorage.removeItem('codeSecond');
			$('body').addClass('is-loader');
			const url = $('.js-contact-url').text();
			if ($('.wpcf7-submit').hasClass('js-contact-form')) {
				window.location.href = url;
			}
			const url2 = $('.js-form-block-url').text();
			if ($('.wpcf7-submit').hasClass('js-request-quote')) {
				window.location.href = url2;
			}
			// $(`#${formId}`).parents(formHolder).addClass(sentClass);
			// $('.' + FormLabel.classMoved).removeClass(FormLabel.classMoved);
			// $('.wpcf7-form .select2-selection__rendered').empty();

			// setTimeout(() => {
			// 	$(formHolder).removeClass(sentClass);
			// }, delay);
		}, false);
	},
	//If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		const splitUrl = url.split('/').includes(FormHelpers.strTriggerURL);
		if (splitUrl && (!$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid))) {
			const url = $('.js-contact-url').text();
			if ($('.wpcf7-submit').hasClass('js-contact-form')) {
				window.location.href = url;
			}
			const url2 = $('.js-form-block-url').text();
			if ($('.wpcf7-submit').hasClass('js-request-quote')) {
				window.location.href = url2;
			}
		}
	}
};

export default FormHelpers;
